(function ($) {
  "use strict";

  // Esperar a que el DOM esté listo
  $(document).ready(function () {
    // SCROLL AUTOMATICO EN LOS FILTROS
    if (window.location.href.indexOf("?_sft_") > 0) {
      var ele = $(".search-filter-results");
      if (ele.length) {
        $(window).scrollTop(ele.offset().top).scrollLeft(ele.offset().left);
      }
    }

    // MODAL
    var modal = $(".modal-form");
    $(".show-modal").on("click", function (e) {
      e.preventDefault();
      var kmVal = "";
      var mesesVal = "";
      var mesesEl = document.querySelector('.js-priceBreakdownMonths');
      var kmEl = document.querySelector('.js-priceBreakdownKm');
      if (mesesEl) mesesVal = mesesEl.textContent.replace(/\D/g, '').trim();
      if (kmEl) kmVal = kmEl.textContent.replace(/\D/g, '').trim();
      if (!kmVal || !mesesVal) {
        var allKmInputs = document.querySelectorAll('.kmvar');
        var allMesesInputs = document.querySelectorAll('.mesesvar');
        for (var i = 0; i < allKmInputs.length; i++) {
          if (!allKmInputs[i].closest('.c-modal-form__wrapper') && allKmInputs[i].value) {
            kmVal = allKmInputs[i].value; break;
          }
        }
        for (var j = 0; j < allMesesInputs.length; j++) {
          if (!allMesesInputs[j].closest('.c-modal-form__wrapper') && allMesesInputs[j].value) {
            mesesVal = allMesesInputs[j].value; break;
          }
        }
      }
      var modalKm = document.querySelector('.c-modal-form__wrapper .kmvar');
      var modalMeses = document.querySelector('.c-modal-form__wrapper .mesesvar');
      if (modalKm) modalKm.value = kmVal;
      if (modalMeses) modalMeses.value = mesesVal;
      modal.fadeIn();
    });

    $(".close-modal, .modal-div, .close-send").on("click", function (e) {
      e.preventDefault();
      modal.fadeOut();
    });

    // TESTIMONIES SLIDER
    if ($(".testimonios").length) {
      $(".testimonios").slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 890,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // SINGLE OFERTA GALLERY
    if ($(".gallery-slider").length) {
      $(".gallery-slider").slick({
        customPaging: function (slider, i) {
          var thumb = $(slider.$slides[i]).data("thumb");
          return '<a><img src="' + thumb + '"></a>';
        },
        autoplay: false,
        dots: true,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 890,
            settings: {
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // GLightbox
    if (typeof GLightbox !== "undefined") {
      var lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: false,
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
        },
      });
    }

    // COLOR CHECKING
    $(".checking").each(function () {
      $(this).find("li:first").addClass("active");
    });

    $(document).on("click", ".checking li", function () {
      var path = $(this).attr("data-src");
      var alt = $(this).attr("data-alt");
      var name = $(this).attr("data-name");
      var idcampana = $(this).attr("data-idcampana");

      if (name !== undefined && name !== null && name !== "") {
        $(".c-selector__color__value, .check-colors").text(name);

        $(".checking li").removeClass("active");
        $(".checking li").filter(function () {
          return $(this).attr("data-name") === name;
        }).addClass("active");
      } else {
        var $this = $(this);
        $this.parent().find("li").removeClass("active");
        $this.addClass("active");
      }

      if (path) {
        /* Find the Swiper carousel to change his first image src and alt text*/
          const swiperEl = document.querySelector(".js-renting-swiper");

          if (swiperEl) {
              const firstSlideImages = swiperEl.querySelectorAll(
                  '.swiper-slide[data-swiper-slide-index="0"] img'
              );

              if (firstSlideImages.length) {
                  firstSlideImages.forEach(function (img) {
                      img.setAttribute("src", path);
                      if (alt !== undefined) {
                        img.setAttribute("alt", alt);
                      }
                  });
                  
              /* Fallback to change the first image recovered if first try fails */
              } else {
                  const firstImage = swiperEl.querySelector(".swiper-slide img");

                  if (firstImage) {
                      firstImage.setAttribute("src", path);
                      if (alt !== undefined) {
                        firstImage.setAttribute("alt", alt);
                      }
                  }
              }

              if (swiperEl.swiper) {
                  swiperEl.swiper.slideToLoop(0, 0);
                  swiperEl.swiper.update();
              }
          }

          /* Find the Swiper lightbox to change first image src and alt text */
          const lightboxEl = document.querySelector(".renting-lb-swiper");

          if (lightboxEl) {
              const firstLightboxImages = lightboxEl.querySelectorAll(
                  '.swiper-slide[data-swiper-slide-index="0"] img'
              );
              firstLightboxImages.forEach(function (img) {
                  img.setAttribute("src", path);
                  if (alt !== undefined) {
                    img.setAttribute("alt", alt);
                  }
              });

              if (lightboxEl.swiper) {
                  lightboxEl.swiper.update();
              }
          }
      }

      if (idcampana !== undefined && idcampana !== null && idcampana !== "") {
        $('input[name="idcampana"], [id^="idcampana"]').each(function () {
          this.value = idcampana;
          $(this).trigger('change');
          this.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      if (name !== undefined && name !== null && name !== "") {
        $('input[name="idcolor"], [id^="idcolor"]').each(function () {
          this.value = name;
          $(this).trigger('change');
          this.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });

    $("li[data-slide]").click(function (e) {
      e.preventDefault();
      var slideno = $(this).data("slide");
      $(".gallery-slider").slick("slickGoTo", slideno - 1);
    });

    // TABS
    $("body").addClass("js");

    var $toggle = $(".toggle");

    $toggle.on("click", function (e) {
      e.preventDefault();
      var $this = $(this);

      $this.toggleClass("active");
      $this.next(".toggle-panel").toggleClass("active");
    });

    // CAR DETAIL EQUPAMENT TABS
    var $tabbed = $(".tabs");
    $tabbed.on("click", function (e) {
      e.preventDefault();

      const isDesktop = window.matchMedia("(min-width: 960px)").matches;

      var $this = $(this);

      if (isDesktop) {

        $tabbed.each(function () {
          $(this).removeClass("active")
        });
        $(".tabspanel").each(function () {
          $(this).removeClass("active")
        });

        $this.addClass("active");
        $this.next(".tabspanel").addClass("active");

      } else {
        $this.toggleClass("active");
        $this.next(".tabspanel").toggleClass("active");
      }

    });

    var $filtertab = $('.filter-tab');
    $filtertab.on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('active');
      $this.next('.searchandfilter').toggleClass('active');
      $this.next('.filter-panel').toggleClass('active');
      $this.next('.tab--container').toggleClass('active');
    });

    var $readmore = $('[id*="more-"]');
    $readmore.on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('active');
      $this.next('.read-more').toggleClass('active');
    });

    // COLLAPSABLE MENU
    $(".has-submenu > a").click(function (e) {
      var $this = $(this);
      e.preventDefault();

      if ($this.next("ul").is(".active")) {
        $this.next("ul").toggleClass("active");
        $this.toggleClass("active");
      } else {
        $this.closest("ul").find(".active").next("ul").toggleClass("active");
        $this.closest("ul").find(".active").toggleClass("active");
        $this.next().toggleClass("active");
        $this.addClass("active");
      }
    });

    $("body").click(function (event) {
      if ($(event.target).closest(".has-submenu > a").length === 0) {
        $(".has-submenu > a")
          .closest("ul")
          .find(".active")
          .toggleClass("active");
      }
    });

    $(".has-submenu ul").click(function (e) {
      e.stopPropagation();
    });

    $(".ez-toc-title-toggle a").click(function (e) {
      $("#ez-toc-container").toggleClass("active");
    });

    // Brands dropdown
    $(".desktop-brands").click(function (e) {
      e.stopPropagation();
      $(this).toggleClass("open");
    });

    // Cerrar al hacer clic fuera
    $(document).on("click", function () {
      $(".desktop-brands").removeClass("open");
    });

    // SIDEBAR MAIN MENU
    $("[data-toggle]").click(function (m) {
      var toggle_el = $(this).data("toggle");
      if (toggle_el && toggle_el !== 'filter' && toggle_el !== 'modal' && toggle_el !== 'open' && toggle_el !== 'segunda') {
        m.preventDefault();
        $(toggle_el).toggleClass("open-sidebar");
        m.stopPropagation();
      }
    });

    $(".ham").click(function () {
      this.classList.toggle("active");
    });

    // HEADER STATES
    var MQL = 1018;
    if ($(window).width() > MQL) {

      var headerHeight = $(".js-header").height();
      $(window).on(
        "scroll",
        {
          previousTop: 0,
        },
        function () {

          var currentTop = $(window).scrollTop();
          if (currentTop < this.previousTop) {
            if (currentTop > 0 && $(".cd-header").hasClass("is-fixed")) {
              $(".cd-header").addClass("is-visible");
              $(".sidebar--form").addClass("is-fixed");
              $(".filter--sticky").addClass("is-fixed");
            } else {
              $(".cd-header").removeClass("is-visible is-fixed");
              $(".sidebar--form").removeClass("is-fixed");
              $(".filter--sticky").removeClass("is-fixed");
            }
          } else {
            $(".cd-header").removeClass("is-visible");
            $(".sidebar--form").removeClass("is-fixed");
            $(".filter--sticky").removeClass("is-fixed");
            if (
              currentTop > headerHeight &&
              !$(".cd-header").hasClass("is-fixed")
            )
              $(".cd-header").addClass("is-fixed");
          }
          this.previousTop = currentTop;
        }
      );
    }

    // ANCHOR SCROLL
    $('.glosario-scroll a[href^="#"]').on("click", function (e) {
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top,
          },
          900,
          "swing",
          function () {
            window.location.hash = target;
          }
        );
    });


    // DATA TOGGLES
    var $expand = $(".searchandfilter span.filter_search");
    $expand.on("click", function (e) {
      var $this = $(this);
      e.preventDefault();

      if ($this.next("ul").is(".active")) {
        $this.next("ul").toggleClass("active");
        $this.toggleClass("active");
      } else {
        $this.next().toggleClass("active");
        $this.addClass("active");
      }
    });

    $(".searchandfilter li ul ").click(function (e) {
      e.stopPropagation();
    });

    $('[data-toggle="modal"], [data-toggle="open"]').on(
      "click",
      function (event) {
        event.preventDefault();
        var $target = $($(this).data("target"));
        var classes = $(this).data("classes");
        $target.toggleClass(classes);

        var mesesEl = document.querySelector('.js-priceBreakdownMonths');
        var kmEl = document.querySelector('.js-priceBreakdownKm');
        var mesesVal = mesesEl ? mesesEl.textContent.replace(/\D/g, '').trim() : '';
        var kmVal = kmEl ? kmEl.textContent.replace(/\D/g, '').trim() : '';
        var modalKm = $target[0] ? $target[0].querySelector('.kmvar') : null;
        var modalMeses = $target[0] ? $target[0].querySelector('.mesesvar') : null;
        if (modalKm) modalKm.value = kmVal;
        if (modalMeses) modalMeses.value = mesesVal;

        if (
          $(this).data("toogle-open") === undefined ||
          $(this).data("toogle-open") === true
        ) {
          $('[data-toggle="open"]').toggleClass("active");
        }

        $("body").toggleClass("no-scroll", $target.hasClass(classes));
      }
    );

    // CLOSE POPUP
    // $(".custom--overlay").on("click", function (event) {
    //   if (
    //     $(event.target).is(".close") ||
    //     $(event.target).is(".custom--overlay")
    //   ) {
    //     event.preventDefault();
    //     $(this).removeClass("open");
    //   }
    // });

    // ESC KEY
    // $(document).keyup(function (event) {
    //   if (event.which == "27") {
    //     $(".custom--overlay").removeClass("open");
    //   }
    // });

    // AJAX HANDLERS
    $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
      $('[data-toggle="modal"], [data-toggle="open"]').on(
        "click",
        function (event) {
          event.preventDefault();
          var $target = $($(this).data("target"));
          var classes = $(this).data("classes");
          $target.toggleClass(classes);

          if (
            $(this).data("toogle-open") === undefined ||
            $(this).data("toogle-open") === true
          ) {
            $('[data-toggle="open"]').toggleClass("active");
          }
        }
      );

      var $expand = $(".searchandfilter span.filter_search");
      $expand.on("click", function (e) {
        var $this = $(this);
        e.preventDefault();

        if ($this.next("ul").is(".active")) {
          $this.next("ul").toggleClass("active");
          $this.toggleClass("active");
        } else {
          $this.next().toggleClass("active");
          $this.addClass("active");
        }
      });
    });

    $(document).ajaxComplete(function () {
      $('[data-toggle="segunda"]').on("click", function (event) {
        event.preventDefault();
        var $target = $($(this).data("target"));
        var classes = $(this).data("classes");
        $target.toggleClass(classes);
      });

      $(".custom--overlay").on("click", function (event) {
        if (
          $(event.target).is(".close") ||
          $(event.target).is(".custom--overlay")
        ) {
          event.preventDefault();
          $(this).removeClass("open");
        }
      });
    });

    // VENOBOX - Inicializar después de que todo esté listo
    if (typeof VenoBox !== "undefined") {
      new VenoBox({
        selector: ".renting-single-gallery",
        numeration: true,
        infinigall: true,
        share: false,
        navTouch: true,
        spinner: "rotating-plane",
      });
    }

    // INCREMENTAR LEAD WHATSAPP
    $(document).on('click', '.button--whatsapp', function () {
      var href = $(this).attr('href');
      var phone = "";

      if (href.indexOf('?') !== -1) {
        var urlParams = new URLSearchParams(href.split('?')[1]);
        phone = urlParams.get('phone');
      }

      if (phone) {
        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          type: 'POST',
          data: {
            action: 'increment_lead_whatsapp',
            phone: phone
          }
        });
      }
    });

    window.rf_toggle_price = function () {
      var $activeSwitch = $('.c-switch__option.is-active');
      if ($activeSwitch.length) {
        var target = $activeSwitch.data('target') || $activeSwitch.attr('data-target');
        if (target === 'sin-iva') {
          $('.item-price-coniva, #item-price-down').hide();
          $('.item-price-siniva').show();
          $('.card_price_tax, .card_price_text_tax').hide();
          $('.card_price_no_tax, .card_price_text_not_tax').show();
        } else if (target === 'con-iva') {
          $('.item-price-siniva').hide();
          $('.item-price-coniva, #item-price-down').show();
          $('.card_price_no_tax, .card_price_text_not_tax').hide();
          $('.card_price_tax, .card_price_text_tax').show();
        }
        return;
      }

      if ($('#toggle_tax').length) {
        if ($('#toggle_tax').is(':checked')) {
          $('.card_price_no_tax, .card_price_text_not_tax').hide();
          $('.card_price_tax, .card_price_text_tax').show();
        } else {
          $('.card_price_tax, .card_price_text_tax').hide();
          $('.card_price_no_tax, .card_price_text_not_tax').show();
        }
      }
    };

    $(document).on('click', '.c-switch__option', function (e) {
      e.preventDefault();
      var target = $(this).attr('data-target');

      $('.c-switch__option').removeClass('is-active');
      $('.c-switch__option[data-target="' + target + '"]').addClass('is-active');

      window.rf_toggle_price();

      var priceBlock = document.querySelector('.c-selector-price');
      if (priceBlock) priceBlock.setAttribute('data-active', target);
    });

    $(document).on('click', '.c-card__link', function (e) {
      var $activeSwitch = $('.c-switch__option.is-active');
      if ($activeSwitch.length) {
        var target = $activeSwitch.data('target') || $activeSwitch.attr('data-target');
        if (target && this.href && !this.href.startsWith('#') && !this.href.startsWith('javascript:')) {
          try {
            var url = new URL(this.href, window.location.origin);
            url.searchParams.set('iva', target);
            this.href = url.toString();
          } catch (err) { }
        }
      }
    });

    $('#js-filters__modal-close').on('click', function (event) {
      event.preventDefault();
      $("body").removeClass("no-scroll");
      $('#filtro').removeClass('is-visible');
    });

    //equipamiento tabs

    document.querySelectorAll('.js-tab-component').forEach(function (component) {
      var triggers = component.querySelectorAll('.js-tab-trigger');
      var panels = component.querySelectorAll('.js-tab-panel');

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var type = trigger.dataset.type;

          // Reset triggers (clase de estilo)
          triggers.forEach(function (t) {
            t.classList.remove('c-tab-group__item--selected');
            t.setAttribute('aria-selected', 'false');
          });

          // Reset panels (clase de estilo)
          panels.forEach(function (p) {
            p.classList.remove('is-active');
          });

          // Activar trigger y panel actuales
          trigger.classList.add('c-tab-group__item--selected');
          trigger.setAttribute('aria-selected', 'true');

          var panel = component.querySelector('.js-tab-panel[data-type="' + type + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });

    /* if there is a c-hero__detail-image then body has white background */
    if (document.querySelector('.c-hero__detail-image')) {
      document.body.style.background = '#fff';
    }
  });
})(jQuery);
